import AceEditor from "react-ace";
import {useEffect, useRef, useState} from "react";

import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/webpack-resolver";
import {CONTENT_TYPE_APPLICATION_JSON} from "../constants/constants"; // required to get mode-json working https://github.com/securingsincity/react-ace/issues/725#issuecomment-543109155
function Editor(props) {

    const editorRef = useRef(null);
    const [width, setWidth] = useState(props.width || '100%');
    const [height, setHeight] = useState(props.height || '100%');
    //const [body, setBody] = useState(props.body);

    useEffect(() => {
        console.log('MOUNT_EDITOR',props)
    }, []);


    useEffect(() => {
        let scroller = document.querySelector('.ace_scroller')
        //console.log('UPDATE_EDITOR_SIZE',scroller)
        if (scroller) {
           setTimeout( () => {
             //  scroller.style.left='auto'
           },100)
        }
    }, [props.didResize]);


    function onEditorChanged(newValue) {
        //console.log("EDITOR_CHANGED:", newValue);
        if (props.contentType === CONTENT_TYPE_APPLICATION_JSON) {
            try {
                let json = JSON.parse(newValue)
                props.onEditorChanged(json)
            }
            catch (e) {
                console.log('Invalid json',newValue)
            }
        } else {
            props.onEditorChanged(newValue)
        }
    }

    function contentTypeToMode () {
        //console.log('CONTENT_TYPE_MODE',props.contentType)
        if (props.contentType === 'application/json') {
            return 'json'
        }
        return 'plain_text'
    }

    function value () {
        console.log('CONTENT_TYPE_MODE',props.contentType,'BODY',props.body)
        if (props.contentType === 'application/json') {
            return JSON.stringify(props.body || {}, null, 2)
        }
        return props.body
    }

    return (
        <div className="editor">
            <AceEditor
                onLoad={editorInstance => {
                   // console.log('ON_LOAD',editorInstance)
                }}
                ref={editorRef}
                mode={contentTypeToMode()}
                theme="dracula"
                onChange={onEditorChanged}
                value={value()}
                height={height}
                width={width}
            ></AceEditor>
        </div>
    );
}

export default Editor;
